import React from "react";
import TermsAndPrivacyPanel from "container/termsAndPrivacy/TermsAndPrivacyPanel";
import PropTypes from "prop-types";

RootTerms.propTypes = {
  language: PropTypes.string
};

function RootTerms(props) {
  const { language } = props;

  return <TermsAndPrivacyPanel language={language} type={"terms"} />;
}

export default RootTerms;
